import { render, staticRenderFns } from "./games-filter-list.vue?vue&type=template&id=5a150087&scoped=true&"
import script from "./games-filter-list.vue?vue&type=script&lang=js&"
export * from "./games-filter-list.vue?vue&type=script&lang=js&"
import style0 from "./games-filter-list.vue?vue&type=style&index=0&id=5a150087&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a150087",
  null
  
)

export default component.exports